import React from 'react';
import { Form } from 'react-bootstrap';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
export function EmployeeActivityTotalsRow(_ref) {
  let {
    claim,
    isShowInvolvement
  } = _ref;
  const claimEmployeeTotalSalary = (Number(claim.employee_base_salary_total) + Number(claim.employee_bonus_total)).toString();
  const defineColSpan = () => {
    let colSpan;
    if (isShowInvolvement) {
      colSpan = 4;
    } else if (claim.claim_group.project_methodology === 'project_basis') {
      colSpan = 3;
    } else {
      colSpan = 2;
    }
    ;
    return colSpan;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: defineColSpan()
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '70pt',
      maxWidth: '70pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    object: claim,
    disabled: true,
    name: "employees_weighted_rnd",
    type: "text",
    size: "sm"
  })), isShowInvolvement && /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: {
      ...claim,
      claim_employee_total_salary: claimEmployeeTotalSalary
    },
    disabled: true,
    name: "claim_employee_total_salary",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_qualifying_rnd_expenditure",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null)));
}